import React from "react";
import {Button, Col, Container, Row} from "shards-react";
import {connect} from "react-redux";
import PageTitle from "./../../components/common/PageTitle";
import TableData from "./../../components/tables";
import {searchPharmacies, updatePharmacy} from '../../actions/pharmacies.action';
import {Link} from "react-router-dom";

class Pharmacies extends React.Component {
    constructor(props) {
        super(props);
        this.props.loadData();
    }
    updatePharmacy = (e) => {
        let id = e.target.getAttribute("data-id");
        let active = e.target.getAttribute("data-active") !== 'true';
        let payload = {
            id: id,
            active: active
        };
        this.props.updatePharmacy(payload)
        this.props.loadData();
    }
    resetFilters = () => {
        this.props.loadData();
    }
    render() {
        return (
            <Container fluid className="main-content-container px-4">
                <Row noGutters className="page-header py-4">
                    <PageTitle title="Pharmacies" subtitle="pharmacies" className="text-sm-left mb-3"/>
                </Row>
                <Row>
                    <Col className="col-lg col-lg-12 mb-3">
                        <Button theme="secondary" onClick={this.resetFilters}>Reset la recherche</Button>
                    </Col>
                    <Col className="col-lg lg-12 mb-12 col-lg-12 mb-12">
                        {this.props.pharmacies.fetching ? (
                            <div className="flex-center">
                                <div className="text-center d-block">
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <TableData
                                research={this.props.pharmacies.searching}
                                tableData="pharmacies"
                                dataColumns={[
                                    {
                                        Header: "finess et",
                                        accessor: "noFinessEt",
                                        maxWidth: 140,
                                        className: "text-center",
                                        Cell: row => (
                                            <span>{row.original.no_finess_et}</span>
                                        ),
                                    },
                                    {
                                        Header: "siret",
                                        accessor: "siret",
                                        maxWidth: 140,
                                        className: "text-center",
                                        Cell: row => (
                                            <span>{row.original.siret}</span>
                                        ),
                                    },
                                    {
                                        Header: "Raison sociale",
                                        accessor: "rs",
                                        maxWidth: 340,
                                        className: "text-center",
                                        Cell: row => (
                                            <span>{row.original.rs}</span>
                                        ),
                                    },
                                    {
                                        Header: "Adresse",
                                        accessor: "adresse",
                                        maxWidth: 400,
                                        className: "text-center",
                                        Cell: row => (
                                            <span>{row.original.num_voie + ' '+row.original.typ_voie+' '+row.original.voie+' '+row.original.ligne_acheminement}</span>
                                        ),
                                    },
                                    {
                                        Header: "Téléphone",
                                        accessor: "telephone",
                                        maxWidth: 140,
                                        className: "text-center",
                                        Cell: row => (
                                            <span>{row.original.telephone}</span>
                                        ),
                                    },
                                    {
                                        Header: "Provider",
                                        accessor: "provider",
                                        maxWidth: 100,
                                        className: "text-center",
                                        Cell: row => (
                                            <span>{row.original.provider? row.original.provider.name : null}</span>
                                        ),
                                    },
                                    {
                                        Header: "Activer ?",
                                        accessor: "active",
                                        maxWidth: 100,
                                        className: "text-center",
                                        Cell: row => (
                                            <div>
                                                { row.original.active ===true ?
                                                    <Button
                                                        size="sm"
                                                        theme="primary"
                                                        data-id={row.original.no_finess_et}
                                                        data-active={row.original.active}
                                                        onClick={(row) => this.updatePharmacy(row)}
                                                    >Active</Button>
                                                    :
                                                    <Button
                                                        size="sm"
                                                        theme="secondary"
                                                        data-id={row.original.no_finess_et}
                                                        data-active={row.original.active}
                                                        onClick={(row) => this.updatePharmacy(row)}
                                                    >Inactive</Button>
                                                }
                                            </div>
                                        ),
                                    },
                                    {
                                        Header: "Editer",
                                        accessor: "edit",
                                        maxWidth: 100,
                                        className: "text-center",
                                        Cell: row => (
                                            <div>
                                                <Link to={'/pharmacies/' + row.original.no_finess_et}>
                                                    Editer
                                                </Link>
                                            </div>
                                        )
                                    }
                                ]}
                                dataSearch={searchPharmacies}
                                pageSize={100}
                                title={"Liste des pharmacies"}
                                dataName={'pharmacies'}
                            />
                        )}
                    </Col>
                </Row>
            </Container>
        );
    }
}


function mapStateToProps(state) {
    return {
        pharmacies: state['pharmacies'],
    };
}

const mapDispatchToProps = dispatch => ({
    loadData: (e) => dispatch(searchPharmacies(e)),
    updatePharmacy: (e) => dispatch(updatePharmacy(e))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Pharmacies);



// WEBPACK FOOTER //
// ./src/views/Pharmacies/Pharmacies.js